module.exports = __webpack_public_path__ + "img/noimg.8b053bef.png";